export type FilterValue = string | number | boolean | string[];

export type GridSingleFilter = {
  type?: FilterOperator;
  filter?: FilterValue;
  filter2?: FilterValue;
};

export type GridFilters = Record<string, GridSingleFilter>;

export type GridFiltersChangeFn = (filters: GridFilters) => void;

export enum FilterOperator {
  Equals = 'equals',
  NotEqual = 'notEqual',
  Contains = 'contains',
  NotContains = 'notContains',
  StartsWith = 'startsWith',
  EndsWith = 'endsWith',
  LessThanOrEqual = 'lessThanOrEqual',
  LessThan = 'lessThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  GreaterThan = 'greaterThan',
  InRange = 'inRange',
  Empty = 'empty',
  NotEmpty = 'notEmpty',
}

export const getFilterOperators = (
  inputType?: string,
): readonly FilterOperator[] => {
  switch (inputType) {
    case 'checkbox':
    case 'select':
    case 'radio':
    case 'internal.status':
    case 'internal.contentType':
      return [
        FilterOperator.Equals,
        FilterOperator.NotEqual,
        FilterOperator.Empty,
        FilterOperator.NotEmpty,
      ];
    case 'geo':
    case 'simpleList':
    case 'datasource':
    case 'object':
    case 'webhookActions':
      return [
        FilterOperator.Contains,
        FilterOperator.NotContains,
        FilterOperator.Empty,
        FilterOperator.NotEmpty,
      ];
    case 'number':
    case 'dateTime':
      return Object.values(FilterOperator);
    default:
      return [
        FilterOperator.Equals,
        FilterOperator.NotEqual,
        FilterOperator.Contains,
        FilterOperator.NotContains,
        FilterOperator.StartsWith,
        FilterOperator.EndsWith,
        FilterOperator.Empty,
        FilterOperator.NotEmpty,
      ];
  }
};

export const getDefaultFilterOperator = (inputType?: string): FilterOperator =>
  [
    'checkbox',
    'select',
    'radio',
    'internal.status',
    'internal.contentType',
  ].includes(inputType ?? '')
    ? FilterOperator.Equals
    : FilterOperator.Contains;
